import { translate as mainTranslate } from 'loankeeper-common/helpers'

import translate from './translator'

export const translateBase = (name: string): string => mainTranslate('LKMESSAGE', name)
export const translatePermissions = (name: string): string => mainTranslate('frm_sec_RL_add_edit', name)
export const translateCollaterals = (name: string): string => mainTranslate('frm_collaterals', name)
export const translateWebMessage = (key: string): string => mainTranslate(`frm_web_messages-${key}`)

export const getWindowName = ({ base }: any, ID: number) =>
  `${translate('frm_loan_view')} - ${base?.FullName} - ${base?.ISO} (ID ${ID})`

export const getUri = (data, ID: number, hash: string) => `/secure/loan/${ID}/details/${hash}`
